import { Directive, HostListener } from '@angular/core';

/**
 * This class intercepts 'Enter' keyup event and halts their propagation after ok() is called.
 * Note to inheritors: this may impact the behavior of the 'Enter' key for individual elements in the component.
 */
@Directive()
export abstract class KeyHandlerDirective {
    /** Can be set to true to ignore the next press of the Enter key.
     *  Automatically reset to false after the first occurrence.
     */
	public override = false;
	public setOverride(override: boolean) { this.override = override; }

    abstract ok(): void;

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            if (!this.override) {
                this.ok();
                event.stopPropagation();
            }
            this.override = false;
        }
    }
}
